import { useEffect, useState } from "react"

import { Form, Input, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"
import { Link, useNavigate } from "react-router-dom"

import Icon from "../../Icon"
import ButtonComponent from "../Button"
import InputComponent from "../Input"

const { Text, Link: AntLink } = Typography

function LoginForm({ onSubmit, error, otpRequired, resetError, ...props }) {
  const [errorText, setErrorText] = useState(null)
  const [errorLink, setErrorLink] = useState(null)
  const [isBackError, setIsBackError] = useState(false)

  const [form] = Form.useForm()
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    if (error) {
      setIsBackError(true)
      if (typeof error === "string") {
        setErrorText(error)
      } else {
        setErrorText(error?.detail)
        setErrorLink(error?.link ?? null)
      }
      resetError()
    }
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [error])

  const onFinish = (values) => {
    onSubmit(values)
  }

  const onFinishFailed = ({ errorFields }) => {
    if (errorFields) {
      setErrorText(errorFields[0]["errors"])
    }
  }

  function handleClearError(e, field) {
    form.setFields([
      {
        name: field,
        errors: []
      }
    ])
    setErrorText(null)
    setErrorLink(null)
    setIsBackError(false)
  }

  function onBlurHandler(e) {
    const target = e.target

    setTimeout(() => {
      let error = form.getFieldError(target.name)
      if (error.length) setErrorText(error[0])
    }, 10)
  }

  return (
    <Form
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      validateTrigger="onSubmit"
      className="login-form"
      layout="vertical"
      form={form}
      requiredMark={false}
    >
      {props.children}

      <Form.Item noStyle shouldUpdate={true}>
        {() => (
          <div className={cls("error-text", { "error-text_empty": !errorText })}>
            {errorText && (
              <>
                <Icon type={"alert_triangle_error"} role={"icon"} />
                <span>{errorText}</span>
                {errorLink && errorText && (
                  <AntLink
                    style={{ fontSize: "12px" }}
                    href={errorLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" " + errorLink}
                  </AntLink>
                )}
              </>
            )}
          </div>
        )}
      </Form.Item>

      <Form.Item
        name="email"
        validateStatus={errorText || isBackError ? "error" : null}
        rules={[
          { type: "email", message: t("The email or password you entered is incorrect.") },
          { required: true, message: t("The email or password you entered is incorrect.") }
        ]}
      >
        <InputComponent
          placeholder={t("Email address")}
          name="email"
          type="email"
          onChange={(e) => handleClearError(e, "email")}
          onBlur={onBlurHandler}
          autoComplete="email"
        />
      </Form.Item>
      <Form.Item
        name="password"
        validateStatus={errorText || isBackError ? "error" : null}
        rules={[{ required: true, message: t("The email or password you entered is incorrect.") }]}
      >
        <Input.Password
          placeholder={t("Password")}
          autoComplete="new-password"
          visibilityToggle
          onChange={(e) => handleClearError(e, "password")}
          /*iconRender={visible => (
            visible
              ? <Icon type="eye" color={'#C5CCE3'}/>
              : <Icon type="eye_invisible" color={'#C5CCE3'}/>
          )
          }*/
        />
      </Form.Item>

      {otpRequired ? (
        <Form.Item
          label="OTP"
          name="otp_pass"
          initialValue={""}
          validateStatus={errorText || isBackError ? "error" : null}
          rules={[{ required: true, message: t("OTP is required") }]}
        >
          <InputComponent
            placeholder={t("6-digit Code")}
            name="otp_pass"
            type="number"
            onChange={(e) => handleClearError(e, "otp")}
          />
        </Form.Item>
      ) : null}

      <ButtonComponent
        type="primary"
        size="large"
        htmlType="submit"
        //className="btn-primary_animation"
        block
        style={{ marginTop: "16px" }}
      >
        {t("Sign In")}
      </ButtonComponent>

      <div className="bottom-part">
        <Link to="/restore-password">{t("Forgot password?")}</Link>
      </div>

      <div style={{ marginTop: "16px" }}>
        <Text type="secondary">{t("Don't have an account?")} </Text>
        <Text
          type="link"
          className="text-link"
          onClick={() => {
            navigate(process.env.REACT_APP_TYPE === "partner" ? "/" : "/sign-up")
          }}
        >
          {t("Sign up here")}
        </Text>
      </div>
    </Form>
  )
}

export default LoginForm
